/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { AsyncResult } from '@msdyn365-commerce/core';
import { Customer } from '@msdyn365-commerce/retail-proxy';
import { IHeaderViewProps } from '../../../modules/header/header';
import {Collapse, Drawer/*, Drawer*/, Module, Node} from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { IHeaderProps as IHeaderExtentionProps } from '../definition-extensions/header.ext.props.autogenerated';

const headerView: React.FC<IHeaderViewProps & IHeaderExtentionProps<{}>> = (props: IHeaderViewProps & IHeaderExtentionProps<{}>) => {
    // const { useStickyHeader } = props.config;
    React.useEffect(() => {
    //    if (props.isMobile) {
            _stickyHeaderSetup();
        // }
    }, [props]);
    const { HeaderTag/*, HeaderContainer*/, HeaderTopBarContainer } = props;
    return (
        <>
            <Module {...HeaderTag}>
                <div className='custom-top-header'>
                    <div className='container'>
                        <Node {...HeaderTopBarContainer}>
                            {props.navIcon}
                            {props.logo}
                            {!props.isMobile && _renderReactFragment(props.search)}
                            {props.preferredStore}
                            {renderLineSperator()}
                            {_renderAccountBlock(props, false)}
                            {!props.isMobile && props.wishListIconDesktop}
                            {props.cartIcon}
                            {_renderReactFragment(props.siteOptions)}
                            <div className='row mobile-search working'>
                                {props.isMobile && _renderReactFragment(props.search)}
                            </div>
                        </Node>
                    </div>
                </div>

                {_renderCollapseMenu(props)}
                <div className='custom-top-menubar'>
                    <div className='container'>
                        <Node className='ms-header__desktop-view'>{_renderReactFragment(props.menuBar)}</Node>
                    </div>
                </div>
                {/*<Node {...HeaderContainer}>

                </Node>*/}
            </Module>
            {props.isMobile && props.staticFiltersData}
        </>
    );
};
/* Sticky header logic*/
function _stickyHeaderSetup(): void {
    // Set header update methods to trigger on scroll
    window.addEventListener('scroll', () => {
        _updateHeader();
    });
    _updateHeader();
}

/* Update header*/
function _updateHeader(): void {
    // Get heights of cookie and promotion banners
    const defaultValue = 0;
    const headerAlertsContainer: HTMLElement | null = document.querySelector('.ms-promo-banner');
    const bannerHeights = headerAlertsContainer ? headerAlertsContainer.offsetHeight : defaultValue;

    // Triggers opacity change of header
    const headerElement = document.querySelector('.ms-header');
    if (headerElement) {
        if (document.documentElement.scrollTop > bannerHeights) {
            headerElement.classList.add('lock-opaque');
        } else {
            headerElement.classList.remove('lock-opaque');
        }
    }

    // Update sticky header position and opacity
    const stickyHeader: HTMLElement | null = document.querySelector('.ms-header__desktop-view');
    const headerLogo: HTMLElement | null = document.querySelector('.ms-header__logo');

    if (stickyHeader && headerLogo) {
        // Fix center sticky header
        const navStickyPos = headerLogo.offsetHeight + bannerHeights;
        if (document.documentElement.scrollTop > navStickyPos) {
            stickyHeader.classList.add('fixed');
        } else {
            stickyHeader.classList.remove('fixed');
        }
    }
}
function _renderCollapseMenu(props: IHeaderViewProps): JSX.Element | null {
    const { MobileMenuLinksContainer, mobileMenuCollapsed } = props;
    return (
        <Collapse className='ms-header__collapsible-hamburger' isOpen={!mobileMenuCollapsed}>
            <Node {...MobileMenuLinksContainer}>
                {_renderReactFragment(props.search)}
                {_renderMobileAccountBlock(props, true)}
                {props.wishListIconMobile}
                {props.siteOptions}
            </Node>
            {renderLineSperator()}
                {_renderReactFragment(props.menuBar)}
            {/*<div className='shop-by-wrapper'>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2527_3374)">
                        <path d="M15.2686 7.56564C15.2881 7.40613 15.2738 7.24428 15.2265 7.09068C15.1792 6.93707 15.1001 6.79517 14.9943 6.67422C14.8872 6.55231 14.7554 6.45461 14.6076 6.38761C14.4598 6.32061 14.2994 6.28585 14.1371 6.28564H1.86286C1.70059 6.28585 1.54023 6.32061 1.39243 6.38761C1.24464 6.45461 1.11281 6.55231 1.00572 6.67422C0.89989 6.79517 0.820762 6.93707 0.7735 7.09068C0.726237 7.24428 0.711902 7.40613 0.73143 7.56564L1.58857 14.4228C1.62226 14.7015 1.75738 14.9581 1.96817 15.1436C2.17896 15.3291 2.45065 15.4305 2.73143 15.4285H13.2914C13.5722 15.4305 13.8439 15.3291 14.0547 15.1436C14.2655 14.9581 14.4006 14.7015 14.4343 14.4228L15.2686 7.56564Z" stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.85715 6.2857V5.71427C2.85715 4.3503 3.39898 3.04219 4.36346 2.07772C5.32793 1.11325 6.63603 0.571411 8 0.571411C9.36397 0.571411 10.6721 1.11325 11.6366 2.07772C12.601 3.04219 13.1429 4.3503 13.1429 5.71427V6.2857" stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.71429 9.71423V11.9999" stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10.2857 9.71423V11.9999" stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_2527_3374">
                            <rect width="16" height="16" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>

                <Drawer
                    className='shob-by-mobile-menu'
                    openGlyph='ms-header__drawer-open'
                    closeGlyph='ms-header__drawer-close'
                    glyphPlacement='end'
                    toggleButtonText=' Shop by'
                >
                    <div>

                        <ul className='sub-shob-by-mobile-menu'>
                           <li><a href='/localy/localy-online/5637144702.c?refiners=%5B%5B5%2C%22Planted+%26+Produced%22%2C5637144576%2C1%2C%22Planted+%26+Produced%22%2C%22%22%5D%5D'>Planted & Produced Localy</a></li>
                           <li><a href='/localy/localy-online/5637144702.c?refiners=%5B%5B5%2C%22Manufactured%22%2C5637144576%2C1%2C%22Manufactured%22%2C%22%22%5D%5D
 '>Manufactured Localy</a></li>
                           <li><a href='/localy/localy-online/5637144702.c?refiners=%5B%5B5%2C%22Packed%22%2C5637144576%2C1%2C%22Packed%22%2C%22%22%5D%5D'>Packed Localy</a></li>
                        </ul>

                    </div>
                </Drawer>
            </div>*/}
        </Collapse>
    );
}

const renderCustomerName = (accountInformation: AsyncResult<Customer>): React.ReactChild => {
    const customer = accountInformation && accountInformation.result;
    return <>{customer ? customer.FirstName || customer.Name : ''}</>;
};

function _renderMobileAccountBlock(props: IHeaderViewProps, renderForMobile: boolean): JSX.Element | null {
    const { AccountInfoDropdownParentContainer/*, signOutLink*/, signInLink, data, accountLinks } = props;

    if (AccountInfoDropdownParentContainer) {
        const accountClassName = classnames(
            'ms-header__drawer',
            AccountInfoDropdownParentContainer.className,
            renderForMobile ? 'account-mobile' : 'account-desktop'
        );

        if (accountLinks) {
            return (
                <>

                {/*    <div className='ms-header__drawer ms-header__account-info account-mobile'>
                        <a href='/myprofile'><span className='ms-wishlist-text-new'>{renderCustomerName(data.accountInformation)}</span>
                            <div className='profile-icon'>

                            </div>
                        </a>
                    </div>
*/}

                 <div className='my-account-icon'>
                     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <g clip-path="url(#clip0_2527_3371)">
                             <path d="M8.00003 9.14287C9.57798 9.14287 10.8572 7.86369 10.8572 6.28573C10.8572 4.70778 9.57798 3.42859 8.00003 3.42859C6.42207 3.42859 5.14288 4.70778 5.14288 6.28573C5.14288 7.86369 6.42207 9.14287 8.00003 9.14287Z" stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                             <path d="M3.12003 13.5999C3.63002 12.7628 4.34678 12.071 5.20141 11.5909C6.05603 11.1108 7.01979 10.8586 8.00003 10.8586C8.98026 10.8586 9.94402 11.1108 10.7986 11.5909C11.6533 12.071 12.37 12.7628 12.88 13.5999" stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                             <path d="M8.00001 15.4286C12.1027 15.4286 15.4286 12.1027 15.4286 7.99998C15.4286 3.8973 12.1027 0.571411 8.00001 0.571411C3.89733 0.571411 0.571442 3.8973 0.571442 7.99998C0.571442 12.1027 3.89733 15.4286 8.00001 15.4286Z" stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                         </g>
                         <defs>
                             <clipPath id="clip0_2527_3371">
                                 <rect width="16" height="16" fill="white"/>
                             </clipPath>
                         </defs>
                     </svg>
                     <Drawer
                         className='my-account'
                         openGlyph='ms-header__drawer-open'
                         closeGlyph='ms-header__drawer-close'
                         glyphPlacement='end'
                         toggleButtonText={renderCustomerName(data.accountInformation)}
                     >

                         <div>
                             <ul className='my-accounts-sub'>
                                 <li><a href='myaccount'>My Account</a></li>
                                 <li><a href='orderhistory'>Order History</a></li>
                                 <li><a href='addressbook'>Address</a></li>
                                 <li><a href='/_msdyn365/signout'>Logout</a></li>
                             </ul>
                         </div>
                     </Drawer>
                 </div>



              {/*  <Drawer
                    className={accountClassName}
                    openGlyph='ms-header__drawer-open'
                    closeGlyph='ms-header__drawer-close'
                    glyphPlacement='end'
                    toggleButtonText={renderCustomerName(data.accountInformation)}
                >
                    <div>
                        {accountLinks ? accountLinks.map((link: React.ReactNode) => link) : false}
                        {signOutLink}
                    </div>
                </Drawer>*/}
                </>
            );
        } else if (signInLink) {
            return (
                <Node {...AccountInfoDropdownParentContainer} className={accountClassName}>
                    {signInLink}
                </Node>
            );
        }
    }
    return null;
}

function _renderAccountBlock(props: IHeaderViewProps, renderForMobile: boolean): JSX.Element | null {
    const {
        AccountInfoDropdownParentContainer,
        AccountInfoDropdownPopoverConentContainer,
      //  accountInfoDropdownButton,
       // signOutLink,
        signInLink,
        //accountLinks
        data
    } = props;

    if (AccountInfoDropdownParentContainer) {
        const accountClassName = classnames(
            AccountInfoDropdownParentContainer.className,
            renderForMobile ? 'account-mobile' : 'account-desktop'
        );
        if (AccountInfoDropdownPopoverConentContainer) {
            return (
                <div className='profile-name ms-header__account-info account-desktop'>
                    <a href='/myaccount'><span className='ms-wishlist-text-new'>{renderCustomerName(data.accountInformation)}</span>
                        <div className='profile-icon'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <path d="M8.00021 9.643C9.57817 9.643 10.8574 8.36381 10.8574 6.78585C10.8574 5.2079 9.57817 3.92871 8.00021 3.92871C6.42225 3.92871 5.14307 5.2079 5.14307 6.78585C5.14307 8.36381 6.42225 9.643 8.00021 9.643Z" stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M3.12012 14.1002C3.63011 13.2631 4.34687 12.5712 5.2015 12.0911C6.05612 11.611 7.01988 11.3589 8.00012 11.3589C8.98035 11.3589 9.94411 11.611 10.7987 12.0911C11.6534 12.5712 12.3701 13.2631 12.8801 14.1002" stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.0001 15.9287C12.1028 15.9287 15.4287 12.6028 15.4287 8.5001C15.4287 4.39742 12.1028 1.07153 8.0001 1.07153C3.89742 1.07153 0.571533 4.39742 0.571533 8.5001C0.571533 12.6028 3.89742 15.9287 8.0001 15.9287Z" stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </a>
                </div>
            );
        } else if (signInLink) {
            return (
                <Node {...AccountInfoDropdownParentContainer} className={accountClassName}>
                    {signInLink}
                </Node>
            );
        }
    }

    return null;
}

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
    return (
        <>
            {items && items.length > 0
                ? items.map((slot: React.ReactNode, index: number) => {
                      return <React.Fragment key={index}>{slot}</React.Fragment>;
                  })
                : null}
        </>
    );
}
function renderLineSperator() {
    return <span className='bar'>|</span>;
}
export default headerView;
